import axios from "axios";
import { toast } from "react-toastify";
import Cookies from 'universal-cookie'
import { io } from "socket.io-client";
import { Logout, markIdleLogoutHome, consumeIdleSessionIfNeeded, SESSION_EXPIRED_EVENT, SESSION_EXPIRED_MSG } from "./common/Funcation";
import { ADMIN_API, USER_API } from "./common/common";
import { normalizeMobileHeaderId, writeHeaderCache } from "./common/mobileHeader";
import { store } from "./redux/store";

const cookies = new Cookies()

const ANONYMOUS_APIS = new Set(["login", "auth/login", "admin/login"]);

function isAnonymousApi(api) {
  const path = String(api || "").split("?")[0].replace(/^\//, "");
  return ANONYMOUS_APIS.has(path);
}

let socket;
let lastPlayerBind = null;

export const getToken = async () => {
  try {
    if (consumeIdleSessionIfNeeded()) {
      return null;
    }
    const auth_token = await cookies.get('skyTokenFront');
    if (auth_token !== null) {
      return auth_token;
    }
  } catch (e) {
    return e;
  }
};

const apiURL = process.env.REACT_APP_API_USER_ENDPOINT;
export const postApi = async (data) => {
  const auth_token = await getToken()
  return axios.post(`${apiURL + data.api}`, data.value, {
    headers: isAnonymousApi(data.api) ? {} : {
      Authorization: data.token || auth_token,
    },
  });
};
export const postApiLink = async (data) => {
  const auth_token = await getToken()

  return axios.post(`${data.api}`, data.value, {
    headers: isAnonymousApi(data.api) ? {} : {
      Authorization: data.token || auth_token,
    },
  });
};

const apiURL_ADMIN = process.env.REACT_APP_API_ENDPOINT;
export const postApiAdmin = async (data) => {
  const auth_token = await getToken()

  return axios.post(`${apiURL_ADMIN + data.api}`, data.value, {
    headers: isAnonymousApi(data.api) ? {} : {
      Authorization: data.token || auth_token,
    },
  });
};

export const getApi = async (data) => {
  const auth_token = await getToken()
  return axios.get(`${apiURL + data.api}`, {
    headers: data.api === 'home' ? {} : {
      Authorization: data.token || auth_token,
    },
  });
};

//fetch live score data from api
// export const getScoreData = async (url) => {
//   try {
//     const response = await fetch(url);

//     if (!response.ok) {
//       throw new Error(`Request failed with status ${response.status}`);
//     }

//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.error("Error fetching score data:", error);
//     throw error; // re-throw so the caller can handle it (e.g. show a UI error)
//   }
// };

export const getApiLink = async (data) => {
  const auth_token = await getToken()

  return axios.get(`${data.api}`, {
    maxBodyLength: "Infinity"
    // headers: data.api === 'admin/login' ? {} : {
    //   Authorization: data.token || auth_token,
    //   "Access-Control-Allow-Origin":"*"
    // },
  });
};
export const notifyMessage = (text) => toast.success(text, {
  className: 'toast-success-container toast-success-container-after',
});

const DEBUG_AUTH_MSG = /^Unauthorized[1-5]$/i;
let handlingSessionExpired = false;

function isSessionExpiredText(text) {
  const raw = String(text || "");
  return (
    DEBUG_AUTH_MSG.test(raw) ||
    /session expired/i.test(raw) ||
    /please log in again/i.test(raw)
  );
}

function isSessionExpiredError(err) {
  const status = err?.response?.status || err?.response?.data?.statusCode;
  const msg = err?.response?.data?.message;
  return status === 401 || isSessionExpiredText(msg);
}

function handleSessionExpired() {
  if (handlingSessionExpired) return;
  handlingSessionExpired = true;
  lastPlayerBind = null;
  markIdleLogoutHome();
  Logout();
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
  }
  setTimeout(() => {
    handlingSessionExpired = false;
  }, 4000);
}

export const notifyError = (text) => {
  if (isSessionExpiredText(text)) return;
  return toast.error(text, {
    className: 'toast-error-container toast-error-container-after',
  });
};

function isOurApiRequest(err) {
  const url = String(err?.config?.url || "");
  if (!url) return false;
  const userApi = process.env.REACT_APP_API_USER_ENDPOINT || "";
  const adminApi = process.env.REACT_APP_API_ENDPOINT || "";
  return (
    (userApi && url.startsWith(userApi)) ||
    (adminApi && url.startsWith(adminApi))
  );
}

function requestHadAuth(err) {
  const headers = err?.config?.headers;
  if (!headers) return false;
  if (typeof headers.get === "function") {
    return Boolean(headers.get("Authorization") || headers.get("authorization"));
  }
  return Boolean(headers.Authorization || headers.authorization);
}

axios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (isOurApiRequest(err) && isSessionExpiredError(err)) {
      if (err?.response?.data) {
        err.response.data.message = SESSION_EXPIRED_MSG;
      }
      if (requestHadAuth(err) && cookies.get("skyTokenFront")) {
        handleSessionExpired();
      }
    }
    return Promise.reject(err);
  }
);

function normalizeSiteHost(host) {
  if (!host) return "";
  let domain = String(host).toLowerCase();
  if (domain.includes("ag.")) {
    domain = domain.split("ag.")[1] || domain;
  } else if (domain.includes("msa.")) {
    domain = domain.split("msa.")[1] || domain;
  }
  return domain.replace(/^www\./, "");
}

function getClientHostname() {
  if (typeof window === "undefined") return "";
  if (window.location.hostname === "localhost" && process.env.REACT_APP_DOMAIN) {
    return process.env.REACT_APP_DOMAIN;
  }
  return window.location.hostname;
}

function isCacheEventForThisSite(eventDomain) {
  if (!eventDomain) return false;
  return normalizeSiteHost(eventDomain) === normalizeSiteHost(getClientHostname());
}

function silentForceLogout(dispatch) {
  lastPlayerBind = null;
  if (cookies.get("skyTokenFront")) {
    handleSessionExpired();
  } else {
    Logout();
  }
  dispatch({ type: "AUTHENTICATION", payload: false });
  dispatch({ type: "LOGOUT" });
  dispatch({ type: "SET_BET_HISTORY_SHOW", payload: false });
}

async function refetchWebsiteCache(dispatch) {
  const hostname = getClientHostname();
  try {
    const homeRes = await getApi({
      api: `${USER_API.HOME}?domain=${hostname}`,
    });
    if (homeRes?.data?.data) {
      dispatch({ type: "SET_HOME_DATA", payload: homeRes.data.data });
    }
  } catch (err) {
    console.error("CACHE_INVALIDATE home refetch failed", err);
  }
  try {
    const siteRes = await postApiAdmin({
      api: ADMIN_API.SETTING.WEBSITE.GET_SITE,
      value: { domain: hostname },
    });
    if (siteRes?.data?.data) {
      dispatch({ type: "DOMAIN_DETAILS", payload: siteRes.data.data });
      writeHeaderCache(normalizeMobileHeaderId(siteRes.data.data.mobileHeader));
    }
  } catch (err) {
    console.error("CACHE_INVALIDATE site refetch failed", err);
  }
}

function openBetsAlreadyOnScreen(betHistory) {
  if (Array.isArray(betHistory)) return true;
  return Array.isArray(betHistory?.betsHistory);
}

let openBetsRefreshAt = 0;
async function refreshOpenBetsAfterWalletUpdate(dispatch) {
  if (!cookies.get("skyTokenFront")) return;
  // Login also pushes a balance update. Reload open bets only if a betting screen already loaded them.
  if (!openBetsAlreadyOnScreen(store.getState()?.betHistory)) return;
  const now = Date.now();
  if (now - openBetsRefreshAt < 800) return;
  openBetsRefreshAt = now;
  try {
    const response = await postApi({
      api: USER_API.BET_LIST,
      value: {},
    });
    dispatch({ type: "USER_BET_HISTORY", payload: response?.data?.data || [] });
  } catch (err) {
    // Wallet update already applied; open-bets refresh is best-effort.
  }
}



export const socketConnect = async (dispatch, next) => {
  const socketApi = process.env.REACT_APP_BASE_POINT;
  // const socketApi = '172.20.11.108:3002';
  socket = io(socketApi, { transports: ['websocket'] });
  socket.on("connect", (res) => {
    next(socket.connected);
    if (lastPlayerBind?.userId) {
      socket.emit("req", requestHandler("SIGN_UP", { userId: lastPlayerBind.userId }));
      if (lastPlayerBind.token) {
        socket.emit("req", requestHandler("VERIFY_TOKEN", lastPlayerBind));
      }
    }
  });
  socket.on("res", (data) => {
    const response = getResponse(data)
    console.log({response})
    if (response) {
      switch (response.data.en) {
        case 'GET_USER_COUNT': {
          dispatch({ type: 'GET_USER_COUNT', payload: response.data.data })
          break;
        }
        case 'GET_LIVE_MATCH_COUNT': {
          dispatch({ type: 'GET_LIVE_MATCH_COUNT', payload: response.data.data })
          break;
        }
        case 'GET_SPORTS_DETAILS': {
          dispatch({ type: 'GET_SPORTS_DETAILS', payload: response.data.data })
          break;
        }
        case 'UPDATE_USER_BALANCE': {
          dispatch({ type: 'UPDATE_USER_BALANCE', payload: response.data.data })
          // Settle/declare pushes wallet over socket, but open-bets Redux is only
          // loaded on page enter / place-bet. Refetch so Book buttons clear without reload.
          void refreshOpenBetsAfterWalletUpdate(dispatch);
          break;
        }
        case 'GET_SPORTS': {
          dispatch({ type: 'GET_SPORTS', payload: response.data.data })
          break;
        }
        case 'GET_SCORE_ID': {
          dispatch({ type: 'GET_SCORE_ID', payload: response.data.data.result })
          break;
        }
        case 'VERIFY_TOKEN': {
          if (response.data?.data?.status === 401) {
            silentForceLogout(dispatch);
          }
          break;
        }
        case 'FORCE_LOGOUT': {
          const keepToken = response.data?.data?.keepToken;
          const current = cookies.get("skyTokenFront");
          if (keepToken && current && String(current) === String(keepToken)) {
            break;
          }
          silentForceLogout(dispatch);
          break;
        }
        case 'CACHE_INVALIDATE': {
          if (!isCacheEventForThisSite(response.data?.domain)) {
            break;
          }
          refetchWebsiteCache(dispatch);
          break;
        }
      }
    }
  });
};

export const getResponse = (data) => {
  return data
}

const requestHandler = (event, data) => {
  return { en: event, data }
}

export const sendEvent = (event, data) => {
  if (event === "SIGN_UP" && data?.userId) {
    lastPlayerBind = { ...(lastPlayerBind || {}), userId: data.userId };
  }
  if (event === "VERIFY_TOKEN" && data?.userId) {
    lastPlayerBind = {
      ...(lastPlayerBind || {}),
      userId: data.userId,
      token: data.token,
    };
  }
  if (socket) {
    socket.emit("req", requestHandler(event, data))
  } else {
    console.warn("Socket not initialized yet, skipping event:", event)
  }
}